import Swal from "sweetalert2";

export const onDeleteWall = (callback) => {
    Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
    }).then((result) => {
        if (result.value) {
            callback();
        }
        else if (result.dismiss === "cancel") { }
    });
}